export const Logout = ({ style, className }) => {
    return (
      <svg
        style={style}
        className={className}
        width="16" 
        height="16" 
        viewBox="0 0 16 16"
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2.66699 12H4.00033V13.3333H12.0003V2.66666H4.00033V3.99999H2.66699V1.99999C2.66699 1.82318 2.73723 1.65361 2.86225 1.52859C2.98728 1.40357 3.15685 1.33333 3.33366 1.33333H12.667C12.8438 1.33333 13.0134 1.40357 13.1384 1.52859C13.2634 1.65361 13.3337 1.82318 13.3337 1.99999V14C13.3337 14.1768 13.2634 14.3464 13.1384 14.4714C13.0134 14.5964 12.8438 14.6667 12.667 14.6667H3.33366C3.15685 14.6667 2.98728 14.5964 2.86225 14.4714C2.73723 14.3464 2.66699 14.1768 2.66699 14V12ZM4.00033 7.33333H8.66699V8.66666H4.00033V10.6667L0.666992 8L4.00033 5.33333V7.33333Z"/>
      </svg>
    );
  };